// REACT
import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { RxAvatar } from "react-icons/rx";
import { useAuth0 } from "@auth0/auth0-react";

// BOOTSTRAP
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

// ASSETS
import navlogo from '../../assets/images/logo.png';
import '../../assets/styles/header.css';
import { IoIosSettings } from "react-icons/io";
import { FiLogOut } from "react-icons/fi";

// CONTEXT
import { maincontext } from '../../context/maincontext';

// SERVICES
// import modalHandler from '../../services/modalHandler';
import { basePath } from '../../routes/routes';
import languagePack from '../../assets/languages/languagePack';

export default function Header(params) {
    const { language, user } = useContext(maincontext);
    // const [showModal, setShowModal] = useState(false);
    // const [modalItem, setModalItem] = useState(null);
    const { logout } = useAuth0();

    return (
        <div>
            <Navbar expand="sm" className="navbar_own">
                <Container>
                    <NavLink to={basePath}>
                        <Navbar.Brand>
                            <img className='navlogo' src={navlogo} alt="Kezdő oldal"></img></Navbar.Brand>
                    </NavLink>

                    <Nav className="nav_align_right">
                        {/* WELCOM SIGN */}
                        <Navbar.Text>
                            <RxAvatar />&nbsp; {user !== null && user !== undefined ? `Hello, ${user.email}!` : `Hello, user!`}
                        </Navbar.Text>
                        {/* SETTINGS */}
                        <NavDropdown align="end" className='settings_icon' title={<IoIosSettings />} id="basic-nav-dropdown">
                            <NavDropdown.Item
                                onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
                            ><FiLogOut className='logout_icon'/>{languagePack[language].nav.logout}</NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                </Container>
            </Navbar>

            {/* MODALS */}
            {/* {showModal && (
                <> {modalItem} </>
            )} */}
        </div>
    )
}